import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getUserInfoMap, getGameServerMap } from "@/utils/dictionary";
export default {
  props: {
    formData: Object,
    PayInfoList: Object
  },
  data: function data() {
    return {
      UserMap: {},
      serverMap: {},
      itemStatus: {
        1: "未发放",
        2: "发放成功",
        3: "发放失败"
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    headStyle: function headStyle() {
      var styleJson = {};
      styleJson = {
        color: "#409EFF"
      };
      return styleJson;
    },
    rowStyle: function rowStyle() {
      var styleJson = {};
      styleJson = {
        color: "#67c23a",
        backgroundColor: "#f0f9eb"
      };
      return styleJson;
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameServerMap();
            case 2:
              _this.serverMap = _context.sent;
              _context.next = 5;
              return getUserInfoMap();
            case 5:
              _this.UserMap = _context.sent;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};